import React from 'react';
import { LeadForm } from '../../components/LeadForm';
export function ScheduleForm() {
  return <div className="sticky top-28" data-id="element-2952">
      <div className="bg-paper p-8 rounded-2xl shadow-xl border border-subtle-gray" data-id="element-2953">
        <h3 className="text-2xl text-ink text-center mb-2" data-id="element-2954">
          Claim Your Free Week
        </h3>
        <p className="text-center text-gray-warm mb-6 text-sm" data-id="element-2955">
          Fill out the form and we'll contact you to schedule your first class.
        </p>
        <LeadForm data-id="element-2956" />
      </div>
    </div>;
}